import Quasi2D from "../../../../src/components/Quasi2D";
import * as React from 'react';
export default {
  Quasi2D,
  React
};